import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        error: "#e63946",
      },
    },
  },
};

// Override VMenu default props
const VMenu = Vue.component("VMenu");
VMenu.options.props.offsetY.default = true;

const selectVMenuOptions = {
  offsetY: true,
  closeOnClick: true,
  closeOnContentClick: true,
};

const VAutoComplete = Vue.component("VAutocomplete");
VAutoComplete.options.props.menuProps.default = () => selectVMenuOptions;
VAutoComplete.options.props.hideDetails.default = "auto";
VAutoComplete.options.props.eager.default = true;

const VSelect = Vue.component("VSelect");
VSelect.options.props.menuProps.default = () => selectVMenuOptions;
VSelect.options.props.hideDetails.default = "auto";
VSelect.options.props.eager.default = true;

const VCombobox = Vue.component("VCombobox");
VAutoComplete.options.props.menuProps.default = () => ({
  offsetY: true,
  closeOnClick: true,
});
VCombobox.options.props.hideDetails.default = "auto";

const VTextField = Vue.component("VTextField");
VTextField.options.props.hideDetails.default = "auto";

const VDataTable = Vue.component("VDataTable");
VDataTable.options.props.expandIcon.default = "mdi-chevron-right";
VDataTable.options.props.customSort.default = (items, sortBy, sortDesc) => {
  if (!sortBy) return items;
  sortBy.map((sort, index) => {
    items = items.sort((a, b) => {
      let A = a;
      let B = b;
      sort
        .split(".")
        .filter((x) => !!x)
        .forEach((item) => (A = A[item]));
      sort
        .split(".")
        .filter((x) => !!x)
        .forEach((item) => (B = B[item]));
      if (["date", "last_run", "created", "last_update_format_ts"].includes(sort)) {
        A = new Date(A);
        B = new Date(B);

        if (sortDesc[index]) {
          return A - B;
        }
        return B - A;
      }

      if (["tags"].includes(sort)) {
        A = A.split(",");
        B = B.split(",");

        if (sortDesc[index]) {
          return A.length - B.length;
        }
        return B.length - A.length;
      }

      if (!isNaN(A) || !isNaN(B)) {
        if (sortDesc[index]) {
          return (A || 0) < (B || 0) ? 1 : -1;
        }
        return (A || 0) > (B || 0) ? 1 : -1;
      }

      let sortA = "";
      let sortB = "";
      if (["testCaseType"].includes(sort)) {
        sortA = String(A);
        sortB = String(B);
      } else {
        sortA = String(A?.[0] ?? A);
        sortB = String(B?.[0] ?? B);
      }

      if (sortDesc[index]) {
        return sortB.localeCompare(sortA);
      }
      return sortA.localeCompare(sortB);
    });
  });
  return items;
};

// const VCheckbox = Vue.component("VCheckbox");
// VCheckbox.options.props.hideDetails.defaults = "auto";

export default new Vuetify(opts);
